import { useContext } from "react";
import { Link } from "react-router-dom";
import { AccessibilityContext } from "../../../contexts/AccessibilityContext";
import marker from "../../../assets/icons/szarymniejszy.gif";
import { useTranslation } from "react-i18next";

export const HeaderSection = () => {
    const { isContrast } = useContext(AccessibilityContext);
    const { t } = useTranslation();

    const fbBg = isContrast 
        ? "bg-gradient-to-r from-yellow-300 to-yellow-500" 
        : "bg-gradient-to-r from-[#1877F2] to-[#3b5998] hover:from-[#3b5998] hover:to-[#1877F2]";
    const liBg = isContrast 
        ? "bg-gradient-to-r from-yellow-300 to-yellow-500" 
        : "bg-gradient-to-r from-[#0A66C2] to-[#0e76a8] hover:from-[#0e76a8] hover:to-[#0A66C2]";
    const iconFill = isContrast ? "#000000" : "#FFFFFF";

    return (
        <section className="flex md:flex-row flex-col pb-[100px]">
            <div className="">
                <h1
                    className={
                        (isContrast ? "text-yellow-400" : "text-black") +
                        " text-custom-14px text-[10px] italic tracking-tighter ml-[2px]"
                    }
                >
                    {t("Technika dla zmysłów, świat bez barier...")}
                </h1>
                <h1
                    className={
                        (isContrast ? "text-yellow-400" : "text-black") +
                        " text-custom-40px font-extrabold md:leading-[60px] leading-[40px]"
                    }
                >
                    {t("System nawigacyjno-informacyjny TOTUPOINT")}
                    <sup style={{ fontSize: "0.75em", lineHeight: "0", paddingLeft: 5 }}>
                        ®
                    </sup>
                </h1>
                <div className="mt-[10px] mb-8 md:w-[500px]">
                    <span
                        className={
                            (isContrast ? "text-yellow-400" : "text-black") +
                            " text-custom-28px font-normal tracking-normal leading-8"
                        }
                    >
                        {t("Tworzymy bezpieczną przestrzeń dla osób niewidomych i słabowidzących")}
                    </span>
                </div>

                <div className="flex flex-row gap-10 mt-5 md:justify-normal justify-center">
                    <div className="bg-cyan-700 hover:bg-cyan-900 rounded-lg text-center flex items-center justify-center">
                        <a href={"#kontakt"} className="text-white text-custom-16px text-center font-medium py-1 px-5">
                            {t("Zadaj pytanie")}
                        </a>
                    </div>
                    <div className="bg-cyan-700 bg-opacity-0 rounded-lg border-2 border-cyan-700 flex items-center justify-center">
                        <a href="#onas" className="text-cyan-700 text-custom-xl font-medium py-1 px-5 hover:bg-cyan-700 hover:text-white">
                            {t("O nas")}
                        </a>
                    </div>
                </div>

                <div className="flex flex-col mt-[5px] gap-[10px]">
                    <span className={(isContrast ? "text-yellow-400" : "text-black") + " mt-[16px] text-custom-17px font-bold"}>
                        {t("Sprawdź nas na: ")}
                    </span>

                    <div className="flex items-center gap-4">
                        <a
                            href="https://www.facebook.com/profile.php?id=100064351974958"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Facebook TOTUPOINT"
                            title="Facebook"
                            className={`w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1 ${fbBg}`}
                        >
                            <svg className="w-6 h-6" role="img" aria-hidden="true" viewBox="0 0 24 24">
                                <path
                                    d="M22.675 0H1.325C.593 0 0 .593 0 1.325v21.35C0 23.407.593 24 1.325 24H12.82v-9.294H9.692v-3.622h3.128V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12V24h6.116c.732 0 1.325-.593 1.325-1.325V1.325C24 .593 23.407 0 22.675 0z"
                                    fill={iconFill}
                                />
                            </svg>
                        </a>
                        <a
                            href="https://www.linkedin.com/company/totupoint/"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="LinkedIn TOTUPOINT"
                            title="LinkedIn"
                            className={`w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1 ${liBg}`}
                        >
                            <svg className="w-6 h-6" role="img" aria-hidden="true" viewBox="0 0 24 24">
                                <path
                                    d="M20.447 20.452h-3.554v-5.569c0-1.328-.026-3.037-1.852-3.037-1.853 0-2.136 1.447-2.136 2.943v5.663H9.351V9h3.414v1.561h.048c.476-.9 1.64-1.852 3.374-1.852 3.608 0 4.274 2.376 4.274 5.466v6.277zM5.337 7.433a2.062 2.062 0 1 1 0-4.124 2.062 2.062 0 0 1 0 4.124zM7.114 20.452H3.557V9h3.557v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.73v20.541C0 23.226.792 24 1.771 24h20.454C23.2 24 24 23.226 24 22.271V1.73C24 .774 23.2 0 22.225 0z"
                                    fill={iconFill}
                                />
                            </svg>
                        </a>
                    </div>
                </div>
            </div>

            <div className="md:mt-[0px] mt-[50px]">
                <img className="md:w-[300px] w-[200px] mx-auto h-full" src={marker} alt={t("Znacznik TOTUPOINT")} />
            </div>
        </section>
    );
};